import React from 'react';
import { Field as FinalField } from 'react-final-form';
import type { FieldState } from 'final-form';
import { DatePickerProps } from '@lendi-ui/date-picker';
import Field from '@lendi-ui/field';

import { useUpdatedRef } from '@funnels/hooks';
import { validateDateString } from '@funnels/utils';

import { FieldLabel } from '../_common/FieldLabel';
import { FieldWrapper } from '../_common/style';
import { CommonFieldProps } from '../_common/types';
import DatePickerInput from './DatePickerInput';

export interface DatePickerInputFieldProps
  extends CommonFieldProps,
    Omit<DatePickerProps, 'monthValue' | 'monthOnChange' | 'yearValue' | 'yearOnChange'> {
  minYears?: number;
  minDate?: string;
  maxDate?: string;
}

const DatePickerInputField = (props: DatePickerInputFieldProps) => {
  const {
    label,
    labelAfter,
    name,
    subLabel,
    validationFailMessage,
    isOptional,
    disableFailMessage = false,
    className,
    minYears,
    minDate,
    maxDate,
    ...rest
  } = props;
  const validationRef = useUpdatedRef({ isDisabled: props.isDisabled, isOptional });
  const validate = (value: any, allValues?: Object, fieldMeta?: FieldState<any>) => {
    if (validationRef.current.isDisabled) {
      return;
    }

    if (props.validate) {
      return props.validate(value);
    }

    return validateDateString(
      validationFailMessage,
      validationRef.current.isOptional,
      props.hasDayField,
      minYears,
      minDate,
      maxDate
    )(value, allValues, fieldMeta);
  };
  const fieldProps = {
    name,
    validate,
  };

  return (
    <FieldWrapper>
      <FieldLabel
        label={label}
        labelAfter={labelAfter}
        subLabel={subLabel}
        isOptional={validationRef.current.isOptional || rest.isDisabled}
      />
      <FinalField {...fieldProps}>
        {({ input, meta }) => (
          <Field {...meta} error={disableFailMessage ? undefined : meta.error}>
            <DatePickerInput
              name={input.name}
              value={input.value}
              className={className}
              isError={!!(meta.error && meta.touched)}
              {...rest}
            />
          </Field>
        )}
      </FinalField>
    </FieldWrapper>
  );
};

export default DatePickerInputField;
